export default __webpack_public_path__ + "static/media/Warning.249130ba.svg";